/* bryan-foamer-configurator: running total, conditional groups, and multi-variant add to cart - Seth S. 2026.9.9 */

(function () {
  'use strict';

  function BryanFoamerConfigurator(root) {
    this.root = root;
    this.groups = Array.prototype.slice.call(root.querySelectorAll('[data-fc-group]'));
    this.summary = root.querySelector('[data-fc-summary]');
    this.totalEl = root.querySelector('[data-fc-total]');
    this.submitEl = root.querySelector('[data-fc-submit]');
    this.errorEl = root.querySelector('[data-fc-error]');
    this.panel = root.querySelector('[data-fc-panel]');
    this.panelToggle = root.querySelector('[data-fc-panel-toggle]');
    this.toggleHint = root.querySelector('[data-fc-toggle-hint]');
    this.modal = root.querySelector('[data-fc-modal]');
    this.modalBody = root.querySelector('[data-fc-modal-body]');
    this.modalClose = root.querySelector('[data-fc-modal-close].bryan-foamer-configurator__modal-close');
    this.modalOpener = null;

    this.formatter = this.buildFormatter(root.dataset.currency || 'USD');
    this.editBuildId = null;
    this.editKeys = [];
    this.selectFromLink();
    this.ensureSingleGroupsHaveAPick();
    this.bind();
    this.refresh();
    this.paintAllSteppers();
    this.restoreBuildFromCart();
  }

  /* bryan-fc-from: a Customize button - on a foamer's product page or its product card - links
     here with ?from=<that product's handle>. Pick the Foamer Type card whose Base bundle is
     that product, so pressing Customize on the double opens on the double. Matched on the
     Base bundle setting rather than a tag, so a new foamer works once its card has a bundle.
     An unknown handle, or none, leaves the page's own default. ?build= (Edit build) wins: the
     restore that follows overwrites this with the build in the cart. - Seth S. 2026.10.1 */
  BryanFoamerConfigurator.prototype.selectFromLink = function () {
    var handle = null;
    try {
      handle = new URLSearchParams(window.location.search).get('from');
    } catch (e) {
      handle = null;
    }
    if (!handle) return;

    var cards = this.root.querySelectorAll('[data-fc-option][data-fc-bundle-handle]');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].dataset.fcBundleHandle === handle && !cards[i].disabled) {
        cards[i].checked = true;
        return;
      }
    }
  };
  /* end bryan-fc-from */

  /* bryan-fc-edit-roundtrip: "Edit build" in the cart sends the shopper back here with
     ?build=<id> and nothing else. The build is read out of the cart rather than out of the
     URL, so what is restored is always what is actually in the cart - a link that has been
     sitting in a tab cannot restore a build that has since changed.

     The selections come from _bryan_build_config rather than from the cart lines, because
     lines merge: a primary and secondary hose of the same length become one line of quantity
     two, and there is no way back from that to which group chose what. */
  /* bryan-fc-edit-stale-keys: the old build is removed by its BUILD ID, read from a fresh copy
     of the cart, never by the line keys remembered when the page loaded. Shopify re-keys
     existing lines whenever the cart changes and its discounts are recalculated - the free
     shirt and the $0 kit both carry an automatic discount - so by the time the new build has
     been added, the remembered keys are stale. Shopify resolves a stale key to the FIRST line
     of that variant, which is the new build's: Update deleted the new free kit or shirt and
     left the old one behind. That is how order #5003 shipped a kit tagged with a different
     build (LFUR) from the rest of its parts (T9TP).

     Quantities go back as a positional array - one figure per cart line, in cart order - so
     nothing in the request depends on a key at all. - Seth S. 2026.10.1 */
  BryanFoamerConfigurator.prototype.removeOldBuild = function (sectionIds) {
    var self = this;
    var oldId = this.editBuildId;
    var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';

    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart unavailable');
        return r.json();
      })
      .then(function (cart) {
        var updates = (cart.items || []).map(function (line) {
          return line.properties && line.properties._bryan_build_id === oldId ? 0 : line.quantity;
        });

        var body = { updates: updates };

        /* bryan-fc-edit-render: ask for the cart sections back from the REMOVAL, not from the
           add. The add's response is a snapshot of the cart with both builds in it, so
           rendering that showed the old build still sitting there even when it had just been
           removed - which looked exactly like the bug this was meant to fix. */
        if (sectionIds && sectionIds.length) {
          body.sections = sectionIds;
          body.sections_url = window.location.pathname;
        }

        return fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('could not remove the old build');
        return r.json();
      })
      .then(function (afterRemoval) {
        self.editBuildId = null;
        self.editKeys = [];
        return afterRemoval;
      })
      .catch(function () {
        /* The new build is already in the cart. Say so plainly rather than silently leaving
           two, which is exactly the confusion this whole change exists to prevent. */
        self.showError(
          'Your updated build was added, but the original could not be removed. Please remove it from your cart.'
        );
        return null;
      });
  };

  BryanFoamerConfigurator.prototype.finishSubmit = function (parsed, useDrawer, cartDrawer) {
    if (useDrawer) {
      /* bryan-fc-drawer-empty: a drawer that loaded with an empty cart carries is-empty, and
         Dawn's CSS hides the whole item list under it. Dawn's own product form clears the
         class before rendering (product-form.js); without the same step the first build
         added to an empty cart opened a drawer showing a total and no items. - Seth S. 2026.9.16 */
      cartDrawer.classList.remove('is-empty');
      /* end bryan-fc-drawer-empty */
      cartDrawer.renderContents(parsed);
      if (typeof cartDrawer.open === 'function') cartDrawer.open();
    } else {
      window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    }
  };

  BryanFoamerConfigurator.prototype.restoreBuildFromCart = function () {
    var self = this;
    var id = null;

    try {
      id = new URLSearchParams(window.location.search).get('build');
    } catch (e) {
      id = null;
    }
    if (!id) return;

    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart unavailable');
        return r.json();
      })
      .then(function (cart) {
        var lines = (cart.items || []).filter(function (line) {
          return line.properties && line.properties._bryan_build_id === id;
        });

        if (!lines.length) {
          self.showError('That build is no longer in your cart, so nothing was restored.');
          return;
        }

        var config = '';
        var units = {};
        for (var i = 0; i < lines.length; i++) {
          if (!config) config = lines[i].properties._bryan_build_config || '';
          self.editKeys.push(lines[i].key);
          var u = parseInt(lines[i].properties._bryan_build_units, 10);
          if (u > 0) units[String(lines[i].variant_id)] = u;
        }

        if (!config) {
          self.showError('That build was added before builds could be edited, so it cannot be reopened.');
          self.editKeys = [];
          return;
        }

        self.editBuildId = id;
        self.applyConfig(config, units);
        self.enterEditMode();
      })
      .catch(function () {
        self.showError('Could not read that build from your cart.');
      });
  };

  BryanFoamerConfigurator.prototype.applyConfig = function (config, units) {
    var segments = config.split('|');
    var wanted = {};
    var i;

    /* bryan-fc-config-qty: entries may read variantId*count. Split the count off into its own
       map; builds saved before counts were recorded fall back to the cart's units below. */
    var counts = {};
    for (i = 0; i < segments.length; i++) {
      var bits = segments[i].split('~');
      if (bits.length !== 2 || !bits[0]) continue;
      var entries = bits[1].split(',');
      var entryIds = [];
      for (var e = 0; e < entries.length; e++) {
        var pair = entries[e].split('*');
        entryIds.push(pair[0]);
        if (pair.length === 2) counts[bits[0] + ':' + pair[0]] = parseInt(pair[1], 10) || 0;
      }
      wanted[bits[0]] = entryIds;
    }

    for (var g = 0; g < this.groups.length; g++) {
      var group = this.groups[g];
      var gid = group.dataset.fcGroupId || '';
      var ids = wanted[gid];

      var options = group.querySelectorAll('[data-fc-option]');
      for (i = 0; i < options.length; i++) {
        var input = options[i];
        if (input.dataset.fcLocked === 'true') continue;

        var vid = input.dataset.fcVariantId || '';
        var on = !!(ids && vid && ids.indexOf(vid) !== -1);

        /* A choose-one group that this build did not record falls back to a None card if it
           has one, rather than being left with whatever the page defaulted to. */
        if (!ids && group.dataset.fcGroupMode === 'single' && input.dataset.fcNone === 'true') {
          on = true;
        }

        if (input.checked !== on) input.checked = on;
      }

      /* Stepper cards carry how many of that part the build held. Only restored when the
         variant appears in one group, since a shared variant's line quantity is a sum. */
      var steppers = group.querySelectorAll('[data-fc-qty-input]');
      for (i = 0; i < steppers.length; i++) {
        var field = steppers[i];
        var card = field.closest('.bryan-foamer-configurator__option');
        var owner = card ? card.querySelector('[data-fc-option]') : null;
        if (!owner) continue;
        var countKey = gid + ':' + owner.dataset.fcVariantId;
        var n = countKey in counts ? counts[countKey] : units[String(owner.dataset.fcVariantId)];
        if (n) this.setCardQuantity(field, n);
      }
    }

    this.ensureSingleGroupsHaveAPick();
    this.refresh();
  };

  BryanFoamerConfigurator.prototype.enterEditMode = function () {
    if (this.submitEl) this.submitEl.textContent = 'Update This Build';

    var note = this.root.querySelector('[data-fc-edit-note]');
    if (note) {
      note.textContent = 'Editing the build already in your cart. Updating replaces it.';
      note.hidden = false;
    }
  };

  /* bryan-fc-guarantee-pick: a choose-one group must never render with nothing
     selected. The pre-selected variant is matched by name in Liquid, and a rename
     in admin can stop it matching - which once left Primary Hose empty, so the
     build silently shipped without a hose. If a group comes back with no pick,
     take the first option that can be selected. */
  BryanFoamerConfigurator.prototype.ensureSingleGroupsHaveAPick = function () {
    for (var i = 0; i < this.groups.length; i++) {
      var group = this.groups[i];
      if (group.dataset.fcGroupMode !== 'single') continue;
      if (group.querySelector('[data-fc-option]:checked')) continue;

      var options = group.querySelectorAll('[data-fc-option]');
      for (var j = 0; j < options.length; j++) {
        if (options[j].disabled) continue;
        if (options[j].dataset.fcUnmapped === 'true') continue;
        options[j].checked = true;
        break;
      }
    }
  };

  BryanFoamerConfigurator.prototype.buildFormatter = function (currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency });
    } catch (e) {
      return null;
    }
  };

  BryanFoamerConfigurator.prototype.money = function (cents) {
    var amount = cents / 100;
    if (this.formatter) return this.formatter.format(amount);
    return '$' + amount.toFixed(2);
  };

  BryanFoamerConfigurator.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('change', function (event) {
      if (event.target.matches('[data-fc-option]')) self.refresh();
      if (event.target.matches('[data-fc-qty-input]')) self.setCardQuantity(event.target, event.target.value);
      if (event.target.matches('[data-fc-variant-select]')) self.setCardVariant(event.target);
    });

    this.root.addEventListener('click', function (event) {
      /* bryan-fc-qty-step: the stepper writes back to the card's own data-fc-qty, so the
         total, the summary and the cart payload all keep reading the one attribute they
         already read. Nothing downstream needs to know a stepper exists. */
      var step = event.target.closest('[data-fc-qty-step]');
      if (step) {
        var wrap = step.closest('[data-fc-qty-wrap]');
        var field = wrap ? wrap.querySelector('[data-fc-qty-input]') : null;
        if (field) {
          var by = parseInt(step.getAttribute('data-fc-qty-step'), 10) || 0;
          self.setCardQuantity(field, (parseInt(field.value, 10) || 0) + by);
        }
        return;
      }

      if (event.target.closest('[data-fc-modal-close]')) {
        self.closeModal();
        return;
      }

      var thumb = event.target.closest('[data-fc-thumb]');
      if (thumb) {
        self.showSlide(thumb.getAttribute('data-fc-thumb'));
        return;
      }

      var toggle = event.target.closest('[data-fc-details-toggle]');
      if (toggle) self.openModal(toggle);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.modal && !self.modal.hidden) self.closeModal();
    });

    if (this.submitEl) {
      this.submitEl.addEventListener('click', function () {
        self.addToCart();
      });
    }

    if (this.panelToggle) {
      this.panelToggle.addEventListener('click', function () {
        var open = self.panel.classList.toggle('is-open');
        self.panelToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (self.toggleHint) self.toggleHint.textContent = open ? 'Hide items' : 'Show items';
      });
    }
  };

  /* bryan-fc-reveal: a group is visible when it has no "show only for" keys, or when at
     least one of its keys is currently selected somewhere on the page. Hidden groups are
     excluded from the total and from the cart payload. - Seth S. 2026.9.9 */
  BryanFoamerConfigurator.prototype.activeRevealKeys = function () {
    var keys = {};
    var checked = this.root.querySelectorAll('[data-fc-option]:checked');
    for (var i = 0; i < checked.length; i++) {
      var key = (checked[i].dataset.fcRevealKey || '').trim();
      if (key) keys[key] = true;
    }
    return keys;
  };

  BryanFoamerConfigurator.prototype.applyReveal = function () {
    var active = this.activeRevealKeys();

    for (var i = 0; i < this.groups.length; i++) {
      var group = this.groups[i];
      var showFor = (group.dataset.fcShowFor || '').trim();
      var visible = true;

      if (showFor) {
        visible = false;
        var wanted = showFor.split(',');
        for (var j = 0; j < wanted.length; j++) {
          if (active[wanted[j].trim()]) {
            visible = true;
            break;
          }
        }
      }

      group.hidden = !visible;
    }
  };

  /* bryan-fc-step: number the sections a shopper can actually see, "1 of 9" and so on. Counted
     after every reveal, because the foamer type swaps some sections for others. A section the
     stylesheet hides - one holding only unmapped placeholders - is skipped as well, so the count
     never includes something that is not on the page. - Seth S. 2026.9.16 */
  BryanFoamerConfigurator.prototype.paintSteps = function () {
    var shown = [];
    for (var i = 0; i < this.groups.length; i++) {
      var group = this.groups[i];
      if (group.hidden || window.getComputedStyle(group).display === 'none') continue;
      shown.push(group);
    }

    for (var j = 0; j < this.groups.length; j++) {
      var step = this.groups[j].querySelector('[data-fc-step]');
      if (!step) continue;
      var at = shown.indexOf(this.groups[j]);
      step.textContent = at === -1 ? '' : at + 1 + ' of ' + shown.length;
    }
  };
  /* end bryan-fc-step */

  BryanFoamerConfigurator.prototype.selections = function () {
    var out = [];

    for (var i = 0; i < this.groups.length; i++) {
      var group = this.groups[i];
      if (group.hidden) continue;

      /* Locked items count whether or not the checkbox reads as checked. They are
         mandatory and the page gives nobody a way to switch them off, so their
         inclusion must not depend on a DOM state we do not control - a restored
         form state on back/forward would otherwise drop them silently. */
      var checked = group.querySelectorAll('[data-fc-option]:checked, [data-fc-option][data-fc-locked="true"]');
      for (var j = 0; j < checked.length; j++) {
        var input = checked[j];
        if (input.disabled) continue;
        if (input.dataset.fcUnmapped === 'true') continue;
        /* a None card is a real selection but buys nothing */
        if (input.dataset.fcNone === 'true') continue;

        out.push({
          id: parseInt(input.dataset.fcVariantId, 10),
          price: parseInt(input.dataset.fcPrice, 10) || 0,
          qty: parseInt(input.dataset.fcQty, 10) || 1,
          baseQty: parseInt(input.dataset.fcBaseQty, 10) || 1,
          locked: input.dataset.fcLocked === 'true',
          inBundle: input.dataset.fcInBundle === 'true',
          basePart: input.dataset.fcBasePart === 'true',
          variantTitle: (input.dataset.fcVariantTitle || '').trim().toLowerCase(),
          label: input.dataset.fcLabel || '',
          productTitle: input.dataset.fcProductTitle || '',
          group: group
        });
      }
    }

    return out;
  };

  /* bryan-fc-bundle: the chosen foamer's base bundle, if it has one. A foamer card with a
     Base bundle set carries every variant of that Shopify Bundles product as JSON (see
     bryan-foamer-option.liquid). Only a card that is chosen and in a visible group counts, so
     switching to a foamer with no bundle - the double, for now - drops straight back to adding
     every part on its own. - Seth S. 2026.10.1 */
  BryanFoamerConfigurator.prototype.activeBundle = function () {
    for (var i = 0; i < this.groups.length; i++) {
      var group = this.groups[i];
      if (group.hidden) continue;
      var chosen = group.querySelectorAll('[data-fc-option][data-fc-bundle]:checked');
      for (var j = 0; j < chosen.length; j++) {
        var input = chosen[j];
        if (!input._fcBundle) {
          try {
            input._fcBundle = JSON.parse(input.dataset.fcBundle);
          } catch (e) {
            input._fcBundle = [];
          }
        }
        if (input._fcBundle.length) return input._fcBundle;
      }
    }
    return null;
  };

  /* bryan-fc-cart-lines: what the build actually puts in the cart, priced. The running total,
     and the payload sent on Add, both come from here so they cannot disagree.

     With a base bundle chosen, every pick ticked "Inside the base bundle" is covered by ONE
     bundle line instead of its own. Which bundle variant: the one whose every option value is
     among the covered picks' variant titles - the hose card reads "50' Hose" and the chemical
     "Pint Sample", and Shopify Bundles names the bundle variant "50' Hose / Pint Sample" from
     exactly those. Covered picks whose title is no option at all (the foamer itself, the
     tank, the tips, all "Default Title") simply match nothing and are ignored, so adding a
     fixed part to the bundle never needs a code change.

     A stepper card inside the bundle is covered only up to its included amount; anything
     above that - spare tips - is still added on its own.

     If no bundle variant matches (a variant renamed in admin, or sold out), the build falls
     back to adding every part on its own, the way it worked before bundles. That keeps a
     foamer sellable rather than blocking the button, and is logged to the console. */
  BryanFoamerConfigurator.prototype.cartLines = function () {
    var picks = this.selections();
    var bundle = this.activeBundle();
    var match = null;
    var lines = [];
    var i;

    if (bundle) {
      var titles = {};
      for (i = 0; i < picks.length; i++) {
        if (picks[i].inBundle && picks[i].variantTitle) titles[picks[i].variantTitle] = true;
      }

      for (i = 0; i < bundle.length; i++) {
        var options = bundle[i].options || [];
        var all = options.length > 0;
        for (var o = 0; o < options.length; o++) {
          if (!titles[options[o]]) {
            all = false;
            break;
          }
        }
        if (all) {
          match = bundle[i];
          break;
        }
      }

      if (match && !match.available) match = null;
      if (!match && window.console) {
        console.warn('bryan-fc-bundle: no available bundle variant matches this build, adding parts individually');
      }
    }

    /* bryan-fc-build-role: every line is marked base or addon, for the packing slip's BASE
       FOAMER and FOAMER ADD-ONS headings. A card ticked "Inside the base bundle" is base - its
       included amount, that is; spare tips above it are addons. Every other card is something
       the shopper chose on top, an addon. This holds whether or not the foamer has a bundle,
       so the double foamer's slip splits the same way before it gets one. The bundle line
       itself is base. A stepper card's base and spare amounts become two lines because their
       roles differ. - Seth S. 2026.10.1 */
    if (match) lines.push({ id: match.id, qty: 1, price: match.price, bundle: true, role: 'base' });

    for (i = 0; i < picks.length; i++) {
      var pick = picks[i];
      /* bryan-fc-base-part: a base part the bundle cannot hold - the double foamer's second
         hose, a second variant of a product the bundle already takes once - is added as its
         own line like an add-on, but marked base for the packing slip. - Seth S. 2026.10.1 */
      if (!pick.inBundle) {
        lines.push({ id: pick.id, qty: pick.qty, price: pick.price, role: pick.basePart ? 'base' : 'addon' });
        continue;
      }

      var baseQty = pick.locked ? Math.min(pick.baseQty, pick.qty) : pick.qty;
      var spare = pick.qty - baseQty;
      if (!match && baseQty > 0) lines.push({ id: pick.id, qty: baseQty, price: pick.price, role: 'base' });
      if (spare > 0) lines.push({ id: pick.id, qty: spare, price: pick.price, role: 'addon' });
    }

    return { lines: lines, bundleVariant: match, picks: picks };
  };
  /* end bryan-fc-bundle */

  /* What each group would contribute if one group's pick were swapped out. Passing
     no override describes the build as it stands. */
  BryanFoamerConfigurator.prototype.effectiveSelections = function (overrideGroup, overrideInput) {
    var out = [];

    for (var i = 0; i < this.groups.length; i++) {
      var group = this.groups[i];
      var inputs;

      if (group === overrideGroup) {
        inputs = overrideInput ? [overrideInput] : [];
      } else {
        inputs = Array.prototype.slice.call(
          group.querySelectorAll('[data-fc-option]:checked, [data-fc-option][data-fc-locked="true"]')
        );
      }

      var usable = [];
      for (var j = 0; j < inputs.length; j++) {
        if (inputs[j].disabled) continue;
        if (inputs[j].dataset.fcUnmapped === 'true') continue;
        usable.push(inputs[j]);
      }

      out.push({ group: group, inputs: usable });
    }

    return out;
  };

  /* bryan-fc-forced-cost: the least this group can cost once it is on screen.

     An "included" group forces everything in it. A choose-one group forces its
     cheapest option, unless it offers a None card, in which case the shopper can
     opt out and it forces nothing. An optional group forces nothing at all. */
  BryanFoamerConfigurator.prototype.forcedCost = function (group) {
    var mode = group.dataset.fcGroupMode;
    var options = group.querySelectorAll('[data-fc-option]');
    var hasNone = false;
    var cheapest = null;
    var sum = 0;

    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      if (opt.dataset.fcNone === 'true') {
        hasNone = true;
        continue;
      }
      if (opt.disabled) continue;
      if (opt.dataset.fcUnmapped === 'true') continue;

      var price = (parseInt(opt.dataset.fcPrice, 10) || 0) * (parseInt(opt.dataset.fcQty, 10) || 1);
      sum += price;
      if (cheapest === null || price < cheapest) cheapest = price;
    }

    if (mode === 'included') return sum;
    if (mode === 'single') {
      if (hasNone) return 0;
      return cheapest === null ? 0 : cheapest;
    }
    return 0;
  };

  /* Which groups would be on screen if one group's pick were swapped out. */
  BryanFoamerConfigurator.prototype.visibilityUnder = function (overrideGroup, overrideInput) {
    var sel = this.effectiveSelections(overrideGroup, overrideInput);
    var keys = {};
    var i, j;

    for (i = 0; i < sel.length; i++) {
      for (j = 0; j < sel[i].inputs.length; j++) {
        var key = (sel[i].inputs[j].dataset.fcRevealKey || '').trim();
        if (key) keys[key] = true;
      }
    }

    var map = [];
    for (i = 0; i < this.groups.length; i++) {
      var showFor = (this.groups[i].dataset.fcShowFor || '').trim();
      var visible = true;

      if (showFor) {
        visible = false;
        var wanted = showFor.split(',');
        for (var w = 0; w < wanted.length; w++) {
          if (keys[wanted[w].trim()]) {
            visible = true;
            break;
          }
        }
      }

      map.push(visible);
    }

    return map;
  };

  /* bryan-fc-forced-delta: what switching to this option really commits you to.

     Its own line, plus whatever the switch forces into or out of the build - a
     double foamer brings a second tank and makes a secondary hose compulsory - and
     nothing else. Groups that are on screen either way contribute the same on both
     sides and cancel, so picking a different hose length can never move the price
     shown on the foamer cards. Revealed groups are counted at their cheapest, so
     the figure is the unavoidable minimum rather than whatever happens to be
     pre-selected further down the page. - Seth S. 2026.9.15 */
  BryanFoamerConfigurator.prototype.forcedDelta = function (group, input) {
    var before = this.visibilityUnder(null, null);
    var after = this.visibilityUnder(group, input);

    var picked = group.querySelector('[data-fc-option]:checked');
    var currentPrice = 0;
    if (picked && picked.dataset.fcNone !== 'true') {
      currentPrice = (parseInt(picked.dataset.fcPrice, 10) || 0) * (parseInt(picked.dataset.fcQty, 10) || 1);
    }

    var candidatePrice = 0;
    if (input.dataset.fcNone !== 'true') {
      candidatePrice = (parseInt(input.dataset.fcPrice, 10) || 0) * (parseInt(input.dataset.fcQty, 10) || 1);
    }

    var delta = candidatePrice - currentPrice;

    for (var i = 0; i < this.groups.length; i++) {
      if (this.groups[i] === group) continue;
      if (before[i] === after[i]) continue;
      if (after[i]) {
        delta += this.forcedCost(this.groups[i]);
      } else {
        delta -= this.forcedCost(this.groups[i]);
      }
    }

    return delta;
  };

  /* bryan-fc-true-delta: the whole build total under a hypothetical pick, including
     any group that pick reveals or hides. A double foamer costs $200 more than a
     single on its own line, but choosing it also forces a secondary hose, so the
     honest number to show the shopper is the difference in grand total, not the
     difference between two line prices. Comparing line prices alone understated
     the double foamer by the entire price of a hose and gun. */
  BryanFoamerConfigurator.prototype.hypotheticalTotal = function (overrideGroup, overrideInput) {
    var sel = this.effectiveSelections(overrideGroup, overrideInput);
    var keys = {};
    var i, j;

    for (i = 0; i < sel.length; i++) {
      for (j = 0; j < sel[i].inputs.length; j++) {
        var key = (sel[i].inputs[j].dataset.fcRevealKey || '').trim();
        if (key) keys[key] = true;
      }
    }

    var total = 0;
    for (i = 0; i < sel.length; i++) {
      var showFor = (sel[i].group.dataset.fcShowFor || '').trim();
      var visible = true;

      if (showFor) {
        visible = false;
        var wanted = showFor.split(',');
        for (var w = 0; w < wanted.length; w++) {
          if (keys[wanted[w].trim()]) {
            visible = true;
            break;
          }
        }
      }

      if (!visible) continue;

      for (j = 0; j < sel[i].inputs.length; j++) {
        var unit = parseInt(sel[i].inputs[j].dataset.fcPrice, 10) || 0;
        var mult = parseInt(sel[i].inputs[j].dataset.fcQty, 10) || 1;
        total += unit * mult;
      }
    }

    return total;
  };

  /* In a choose-one group the selected card reads "Selected" and every other card
     shows what switching to it would do to the build total, with reductions in red.
     Optional groups keep absolute prices, because ticking a second add-on is not a
     swap and has no baseline to measure from. Always-included cards read "Included"
     and are left alone. */
  /* bryan-fc-variant-select: a card whose variant comes from a menu rather than from which
     card was clicked. The chosen option's id, price and name are copied onto the card's own
     data attributes, so the total, the summary and the cart payload keep reading the same
     attributes they read for every other card. */
  BryanFoamerConfigurator.prototype.setCardVariant = function (select) {
    var chosen = select.options[select.selectedIndex];
    if (!chosen) return;

    var card = select.closest('.bryan-foamer-configurator__option');
    var input = card ? card.querySelector('[data-fc-option]') : null;
    if (!input) return;

    input.dataset.fcVariantId = chosen.value;
    input.value = chosen.value;
    if (chosen.dataset.fcOptPrice) input.dataset.fcPrice = chosen.dataset.fcOptPrice;
    if (chosen.dataset.fcOptLabel) {
      input.dataset.fcLabel = chosen.dataset.fcOptLabel;
      /* the menu's label is the bare variant title, which is what a base bundle matches on */
      input.dataset.fcVariantTitle = chosen.dataset.fcOptLabel;
    }

    /* Picking a size means wanting the thing. */
    if (!input.disabled) input.checked = true;

    this.refresh();
  };

  BryanFoamerConfigurator.prototype.setCardQuantity = function (field, next) {
    /* Not `|| 1`: a floor of zero is falsy, so an optional card's stepper refused to go below
       one and the minus looked broken. - Seth S. 2026.9.17 */
    var min = parseInt(field.getAttribute('min'), 10);
    if (isNaN(min)) min = 0;
    var max = parseInt(field.getAttribute('max'), 10);
    if (isNaN(max)) max = 99;

    next = parseInt(next, 10);
    if (isNaN(next) || next < min) next = min;
    if (next > max) next = max;
    field.value = next;

    var card = field.closest('.bryan-foamer-configurator__option');
    var input = card ? card.querySelector('[data-fc-option]') : null;

    if (input) {
      input.dataset.fcQty = next;

      /* bryan-fc-zero-qty: a stepper on a card that is NOT included starts at zero, and zero
         means not chosen. Tying the tick to the count keeps one control instead of asking a
         shopper to both tick a box and set a number. Locked cards are always in the build, so
         they are left alone. */
      if (input.dataset.fcLocked !== 'true') input.checked = next > 0;
    }

    this.paintStepper(field);
    this.refresh();
  };

  /* bryan-fc-stepper-floor: hide the minus once a card is at its floor - one for an included
     part, zero for an optional one - so the control never offers a step it will not take.
     Hidden rather than removed, so the box does not resize on every first click. */
  BryanFoamerConfigurator.prototype.paintStepper = function (field) {
    var wrap = field.closest('[data-fc-qty-wrap]');
    if (!wrap) return;

    var minus = wrap.querySelector('[data-fc-qty-step="-1"]');
    if (!minus) return;

    var min = parseInt(field.getAttribute('min'), 10) || 0;
    var now = parseInt(field.value, 10);
    if (isNaN(now)) now = min;

    minus.disabled = now <= min;
  };

  BryanFoamerConfigurator.prototype.paintAllSteppers = function () {
    var fields = this.root.querySelectorAll('[data-fc-qty-input]');
    for (var i = 0; i < fields.length; i++) this.paintStepper(fields[i]);
  };

  BryanFoamerConfigurator.prototype.paintPrices = function () {
    for (var i = 0; i < this.groups.length; i++) {
      var group = this.groups[i];
      var mode = group.dataset.fcGroupMode;
      if (mode === 'included') continue;

      var options = group.querySelectorAll('[data-fc-option]');

      for (var j = 0; j < options.length; j++) {
        var input = options[j];
        var wrap = input.closest('.bryan-foamer-configurator__option');
        if (!wrap) continue;
        var el = wrap.querySelector('[data-fc-price-el]');
        if (!el || el.dataset.fcPriceStatic === 'true') continue;

        el.classList.remove(
          'bryan-foamer-configurator__price--selected',
          'bryan-foamer-configurator__price--down',
          'bryan-foamer-configurator__price--up'
        );

        var price = (parseInt(input.dataset.fcPrice, 10) || 0) * (parseInt(input.dataset.fcQty, 10) || 1);

        /* bryan-fc-included-price: a card with a stepper is included AND chargeable above the
           included amount, so neither "Included" nor a plain price tells the truth on its own.
           Ordinary included cards never reach here - they carry data-fc-price-static and were
           skipped above. */
        if (input.dataset.fcLocked === 'true') {
          var baseQty = parseInt(input.dataset.fcBaseQty, 10) || 1;
          var qty = parseInt(input.dataset.fcQty, 10) || baseQty;
          var extra = (qty - baseQty) * (parseInt(input.dataset.fcPrice, 10) || 0);
          el.textContent = extra > 0 ? 'Included + ' + this.money(extra) : 'Included';
          el.classList.add('bryan-foamer-configurator__price--included');
          continue;
        }

        /* A stepper card that is not included shows what one costs until some are taken,
           then what they cost together. money(price * 0) would just read as free. */
        var stepper = wrap.querySelector('[data-fc-qty-input]');
        if (stepper) {
          var unit = parseInt(input.dataset.fcPrice, 10) || 0;
          var taken = parseInt(input.dataset.fcQty, 10) || 0;
          el.textContent = this.money(taken > 0 ? unit * taken : unit);
          continue;
        }

        if (mode !== 'single') {
          el.textContent = this.money(price);
          continue;
        }

        if (input.checked) {
          el.textContent = 'Selected';
          el.classList.add('bryan-foamer-configurator__price--selected');
          continue;
        }

        var delta = this.forcedDelta(group, input);
        if (delta < 0) {
          el.textContent = '-' + this.money(-delta);
          el.classList.add('bryan-foamer-configurator__price--down');
        } else {
          el.textContent = '+' + this.money(delta);
          if (delta > 0) el.classList.add('bryan-foamer-configurator__price--up');
        }
      }
    }
  };

  BryanFoamerConfigurator.prototype.refresh = function () {
    this.applyReveal();
    this.paintSteps();
    this.paintPrices();

    /* bryan-fc-bundle: the total is what the cart will charge - the bundle's own price plus
       whatever is added on top - not the sum of the parts, which a bundle need not equal. */
    var built = this.cartLines();
    var picks = built.picks;
    var total = 0;
    var i;

    /* echo the current selection into each visible group heading */
    for (i = 0; i < this.groups.length; i++) {
      var echo = this.groups[i].querySelector('[data-fc-echo]');
      if (!echo) continue;

      var names = [];
      var checked = this.groups[i].querySelectorAll('[data-fc-option]:checked, [data-fc-option][data-fc-locked="true"]');
      /* the same item can appear more than once in a group - a double foamer takes two
         tanks, shown as two cards - and repeating its name in the recap adds nothing */
      for (var k = 0; k < checked.length; k++) {
        if (checked[k].dataset.fcUnmapped === 'true') continue;
        var name = checked[k].dataset.fcLabel || '';
        if (names.indexOf(name) === -1) names.push(name);
      }
      echo.textContent = names.length ? names.join(', ') : 'None';
    }

    for (i = 0; i < built.lines.length; i++) total += built.lines[i].price * built.lines[i].qty;

    /* bryan-fc-summary: a recap of the build, one row per heading and no per-line
       prices. Groups sharing a Summary label merge onto one row, which is how a
       primary and a secondary hose read as a single "Hoses and Guns" line.

       The heading is shown unless the row is a single pick from a choose-one group,
       where the item names itself - "Double Foamer" needs no "Foamer Type:" in front
       of it. An optional group always shows its heading, because one bare "50'" tells
       a shopper nothing about what it is. - Seth S. 2026.9.15 */
    if (this.summary) {
      this.summary.innerHTML = '';

      var rows = [];
      var byLabel = {};

      for (i = 0; i < this.groups.length; i++) {
        var grp = this.groups[i];
        if (grp.hidden) continue;

        var titleEl = grp.querySelector('.bryan-foamer-configurator__group-title');
        var explicit = (grp.dataset.fcSummaryLabel || '').trim();
        var heading = explicit || (titleEl ? titleEl.textContent.trim() : '');
        var chosen = grp.querySelectorAll('[data-fc-option]:checked, [data-fc-option][data-fc-locked="true"]');
        var picked = [];

        for (var m = 0; m < chosen.length; m++) {
          if (chosen[m].disabled) continue;
          if (chosen[m].dataset.fcUnmapped === 'true') continue;
          if (chosen[m].dataset.fcNone === 'true') continue;
          var label = chosen[m].dataset.fcLabel || '';
          if (picked.indexOf(label) === -1) picked.push(label);
        }

        if (!picked.length) continue;

        var row = byLabel[heading];
        if (!row) {
          row = { heading: heading, items: [], alwaysLabel: !!explicit, anyOptional: false };
          byLabel[heading] = row;
          rows.push(row);
        }

        if (grp.dataset.fcGroupMode === 'multi') row.anyOptional = true;

        for (var n = 0; n < picked.length; n++) {
          if (row.items.indexOf(picked[n]) === -1) row.items.push(picked[n]);
        }
      }

      for (var q = 0; q < rows.length; q++) {
        var r = rows[q];
        var li = document.createElement('li');
        li.className = 'bryan-foamer-configurator__summary-item';

        var showHeading = r.alwaysLabel || r.anyOptional || r.items.length > 1;

        if (showHeading) {
          var tag = document.createElement('span');
          tag.className = 'bryan-foamer-configurator__summary-group';
          tag.textContent = r.heading + ': ';
          li.appendChild(tag);
          li.appendChild(document.createTextNode(r.items.join(', ')));
        } else {
          li.textContent = r.items[0];
        }

        this.summary.appendChild(li);
      }
    }

    if (this.totalEl) this.totalEl.textContent = this.money(total);
    if (this.submitEl) this.submitEl.disabled = picks.length === 0;
  };

  /* bryan-fc-modal: fetch the product's own media and description through the Section
     Rendering API and show it in place, so a shopper can inspect a part - including the
     video - without navigating away and losing a half-finished build. The link out to
     the full product page lives inside the modal and opens in a new tab. */
  BryanFoamerConfigurator.prototype.openModal = function (opener) {
    var self = this;
    var url = opener.getAttribute('data-fc-product-url');
    if (!this.modal || !url) return;

    this.modalOpener = opener;
    this.modalBody.innerHTML = '<p class="bryan-foamer-configurator__modal-loading">Loading&hellip;</p>';
    this.modal.hidden = false;
    document.body.classList.add('overflow-hidden');
    if (this.modalClose) this.modalClose.focus();

    var sep = url.indexOf('?') === -1 ? '?' : '&';

    fetch(url + sep + 'section_id=bryan-foamer-detail')
      .then(function (response) {
        if (!response.ok) throw new Error('detail fetch failed');
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var detail = parsed.querySelector('[data-fc-detail]');
        if (!detail) throw new Error('detail markup missing');

        /* a shortened display name replaces the real product title in this view */
        var shortName = opener.getAttribute('data-fc-display-name');
        if (shortName) {
          var heading = detail.querySelector('.bryan-foamer-detail__title');
          if (heading) heading.textContent = shortName;
        }

        /* unlisted products have no page worth sending a shopper to */
        if (opener.getAttribute('data-fc-hide-link')) {
          var link = detail.querySelector('.bryan-foamer-detail__link');
          if (link) link.parentNode.removeChild(link);
        }

        /* a block-level Details override replaces the product's own copy */
        var override = opener.getAttribute('data-fc-details-override');
        if (override) {
          var desc = detail.querySelector('[data-fc-detail-desc]');
          if (desc) desc.innerHTML = override;
        }

        self.modalBody.innerHTML = '';
        self.modalBody.appendChild(detail);
      })
      .catch(function () {
        self.modalBody.innerHTML =
          '<p class="bryan-foamer-configurator__modal-loading">Could not load these details. ' +
          '<a href="' + url + '" target="_blank" rel="noopener">Open the product page</a> instead.</p>';
      });
  };

  BryanFoamerConfigurator.prototype.closeModal = function () {
    if (!this.modal || this.modal.hidden) return;

    /* stop any playing video dead rather than leaving it running behind the overlay */
    var players = this.modalBody.querySelectorAll('video');
    for (var i = 0; i < players.length; i++) {
      try {
        players[i].pause();
      } catch (e) {}
    }
    this.modalBody.innerHTML = '';

    this.modal.hidden = true;
    document.body.classList.remove('overflow-hidden');
    if (this.modalOpener) this.modalOpener.focus();
    this.modalOpener = null;
  };

  BryanFoamerConfigurator.prototype.showSlide = function (index) {
    var slides = this.modalBody.querySelectorAll('[data-fc-slide]');
    var thumbs = this.modalBody.querySelectorAll('[data-fc-thumb]');
    var i;

    for (i = 0; i < slides.length; i++) {
      var on = slides[i].getAttribute('data-fc-slide') === String(index);
      slides[i].classList.toggle('is-active', on);
      if (!on) {
        var v = slides[i].querySelector('video');
        if (v) {
          try {
            v.pause();
          } catch (e) {}
        }
      }
    }

    for (i = 0; i < thumbs.length; i++) {
      thumbs[i].classList.toggle('is-active', thumbs[i].getAttribute('data-fc-thumb') === String(index));
    }
  };

  BryanFoamerConfigurator.prototype.showError = function (message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.hidden = !message;
  };

  BryanFoamerConfigurator.prototype.buildId = function () {
    return Math.random().toString(36).slice(2, 6).toUpperCase();
  };

  BryanFoamerConfigurator.prototype.addToCart = function () {
    var self = this;
    var built = this.cartLines();
    var lines = built.lines;

    if (!lines.length) {
      this.showError('Choose at least one item before adding to the cart.');
      return;
    }

    this.showError('');
    this.submitEl.setAttribute('aria-busy', 'true');
    this.submitEl.disabled = true;

    /* the same variant can be picked in more than one group, so merge quantities - but only
       within one role, since base and add-on lines must stay apart for the packing slip */
    var merged = {};
    var order = [];
    for (var i = 0; i < lines.length; i++) {
      var mkey = lines[i].id + '|' + lines[i].role;
      if (merged[mkey]) {
        merged[mkey].quantity += lines[i].qty;
      } else {
        merged[mkey] = { id: lines[i].id, quantity: lines[i].qty, role: lines[i].role };
        order.push(mkey);
      }
    }

    var buildId = this.buildId();

    /* bryan-fc-build-config: what was chosen, recorded on every line of the build so
       the cart can reopen it for editing. Keyed by the group's block id and variant id
       rather than rebuilt from the cart lines, because two groups can land on the same
       variant - a primary and secondary hose of the same length merge into one line of
       quantity two - and there is no way back from that to which group chose what.
       Verified a 340 character value survives a round trip through the cart. */
    /* bryan-fc-config-bundle: a bundled build records the bundle variant as its FIRST segment,
       under the pseudo group "bundle". The cart row (bryan-cart-bundle.liquid) names and
       pictures a build after the first segment's variant, and the bare foamer is no longer a
       line of its own once it ships inside the bundle - the bundle line is. applyConfig skips
       the segment, since no group on the page has that id. - Seth S. 2026.10.1 */
    var config = [];
    if (built.bundleVariant) config.push('bundle~' + built.bundleVariant.id);
    for (var g = 0; g < this.groups.length; g++) {
      var group = this.groups[g];
      if (group.hidden) continue;
      var gid = group.dataset.fcGroupId || '';
      if (!gid) continue;

      var chosenIds = [];
      var chosen = group.querySelectorAll('[data-fc-option]:checked, [data-fc-option][data-fc-locked="true"]');
      for (var ci = 0; ci < chosen.length; ci++) {
        if (chosen[ci].disabled) continue;
        if (chosen[ci].dataset.fcUnmapped === 'true') continue;
        if (chosen[ci].dataset.fcNone === 'true') continue;
        /* bryan-fc-config-qty: a card at anything other than one records its count as
           variantId*count. Before bundles the count was read back from the cart line, but a
           bundled build's spare tips are a line of the EXTRAS only - the included one is in
           the bundle - so the line no longer says how many the card was set to. */
        var cqty = parseInt(chosen[ci].dataset.fcQty, 10) || 1;
        chosenIds.push(chosen[ci].dataset.fcVariantId + (cqty !== 1 ? '*' + cqty : ''));
      }

      if (chosenIds.length) config.push(gid + '~' + chosenIds.join(','));
    }
    var configString = config.join('|');

    var items = [];
    for (var j = 0; j < order.length; j++) {
      items.push({
        id: merged[order[j]].id,
        quantity: merged[order[j]].quantity,
        /* "Part of" mirrors how the Bundles app labels a bundled line, so the cart,
           order and packing slip all read the same way. The build id stays on the
           hidden property so two separate builds in one cart can still be told
           apart in code. */
        properties: {
          _bryan_build_id: buildId,
          _bryan_build_config: configString,
          /* bryan-fc-build-units: how many of this variant one build contains, kept
             separate from the line quantity so the cart can offer a quantity control
             for the whole build. Two builds doubles every line, and the cart works
             back from line quantity over units to know it is showing two. Without it
             a hose at quantity 4 is indistinguishable from one build that happens to
             use four hoses. - Seth S. 2026.9.16 */
          _bryan_build_units: String(merged[order[j]].quantity),
          _bryan_build_role: merged[order[j]].role,
          'Part of': 'Foamer Configurator'
        }
      });
    }

    var body = { items: items };
    var cartDrawer = document.querySelector('cart-drawer');
    var useDrawer = cartDrawer && typeof cartDrawer.renderContents === 'function';

    if (useDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (parsed) {
        if (parsed.status) {
          self.showError(parsed.description || parsed.message || 'Could not add this build to the cart.');
          return;
        }

        /* bryan-fc-edit-replace: the new build is added BEFORE the old one is removed, so a
           failure between the two leaves the shopper with their original build rather than
           with nothing. The cost of that order is a brief moment holding both, which is the
           safer way round for something worth two thousand dollars. */
        if (self.editBuildId && self.editKeys.length) {
          var sectionIds = body.sections || null;
          return self.removeOldBuild(sectionIds).then(function (afterRemoval) {
            self.finishSubmit(afterRemoval && afterRemoval.sections ? afterRemoval : parsed, useDrawer, cartDrawer);
          });
        }

        self.finishSubmit(parsed, useDrawer, cartDrawer);
      })
      .catch(function () {
        self.showError('Something went wrong adding this build. Please try again.');
      })
      .finally(function () {
        self.submitEl.removeAttribute('aria-busy');
        self.refresh();
      });
  };

  function init() {
    var roots = document.querySelectorAll('[data-bryan-foamer-configurator]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].dataset.fcReady) {
        roots[i].dataset.fcReady = 'true';
        new BryanFoamerConfigurator(roots[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* re-init when the theme editor re-renders the section */
  document.addEventListener('shopify:section:load', init);
})();
